// shared/src/schemas/ticker.ts
// In-flight chain-stage payload schema (not DDL-backed).
// Validates per-ticker context flowing into P-stage step inputs.
// A2 drift-detector SKIPS this schema (no corresponding D1 table).
//
// Full shape locks at Phase 4 Step 16 (chain-workflow wiring) per Plan §4.5.4a
// `TickerData` interface — fields TBD; placeholder kept minimal per
// feedback_no_future_lock_preemption.

import { z } from 'zod';

export const TickerSymbolSchema = z.string().regex(/^\$?[A-Z0-9.\-]+$/);

export const TickerSchema = z.object({
  symbol: TickerSymbolSchema,
  // Additional fields lock at Step 16 (P-stage input contracts).
});

export type Ticker = z.infer<typeof TickerSchema>;
